module.exports = __webpack_public_path__ + "img/flag_rect_180.88f0e397.png";